module.exports = __webpack_public_path__ + "static/img/qrCode.2d2286e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/qrCode.jpg
// module id = Bfft
// module chunks = 10